import { render } from "./CrudPeriodo.vue?vue&type=template&id=76f2857a"
import script from "./CrudPeriodo.vue?vue&type=script&lang=js"
export * from "./CrudPeriodo.vue?vue&type=script&lang=js"

import "./CrudPeriodo.vue?vue&type=style&index=0&id=76f2857a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__